<router-outlet></router-outlet>

<iframe title="logout" id="logout-broker" [src]="baseEnvURL"
    style="width:0;height:0;border:none;position: absolute;"></iframe>